export default __webpack_public_path__ + "static/media/trampapo_01-06.df761053.jpg";